import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gnezccqqak: FaireBrandEntity = {
  token: "b_gnezccqqak",
  type: "brand",
  name: "True Ocean",
  avatarUrl:
    "https://cdn.faire.com/fastly/41cf80856ebedf01cf9e75a49cd949166802b19a97b605151117c656ba71a285.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b11f6e283a3c7e6b93dac33a18c6cba5f8a2fbab78fc7f1789b090da44b58c47.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/41cf80856ebedf01cf9e75a49cd949166802b19a97b605151117c656ba71a285.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b11f6e283a3c7e6b93dac33a18c6cba5f8a2fbab78fc7f1789b090da44b58c47.jpeg",
  location: "Windermere, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 260,
  isTopShop: true,
  isInsider: true,
  description:
    "True Ocean is a Coastal Fragrance and Ocean Water Body Care brand, dedicated to beach centric lifestyle.   Our body care originates with one primary ingredient: water harvested from oceans of the Earth.  Our coastal fragrance includes notes of palm leaf and bergamot.  True Ocean products bring vibes of sand, sun, and surf through nourishing sprays, soaps, lotions, perfume, and body scrubs.   \n\n✓ Made in the USA \n✓ Typically ships ~ under 7 business days\n✓ Premium + Organic ingredients\n✓ Not sold on Amazon\n\nOrder through www.faire.com/direct/trueocean for first time customer promotions! \n\nPerfect for coastal gift shops, resort gifts, and state parks to offer trendy items for beach lovers! 🎁 They're not just great vacation gifts, True Ocean's collection is perfect for birthdays, Valentine's Day, and STOCKING STUFFERS! 🎄 \n\nContact us at [redacted-email] for free samples.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:14.990Z",
    importedBy: "entity-db-cli",
  },
};
